import { Button, Divider, Group, Menu } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import { useSupportLanguage } from "../stores/SupportLanguageStore";

const SupportLanguageChanger = () => {
  const lang = useSupportLanguage((s) => s.language);
  const changeLanguage = useSupportLanguage((s) => s.changeLanguage);

  const langs = [
    {
      value: "FRA",
      label: "Français",
      flagUrl:
        "https://upload.wikimedia.org/wikipedia/commons/c/c3/Flag_of_France.svg",
    },
    {
      value: "ENG",
      label: "English",
      flagUrl:
        "https://upload.wikimedia.org/wikipedia/commons/8/83/Flag_of_the_United_Kingdom_%283-5%29.svg",
    },
    {
      value: "SPA",
      label: "Español",
      flagUrl:
        "https://upload.wikimedia.org/wikipedia/commons/9/9a/Flag_of_Spain.svg",
    },
    {
      value: "ITA",
      label: "Italiano",
      flagUrl:
        "https://upload.wikimedia.org/wikipedia/commons/0/03/Flag_of_Italy.svg",
    },
    {
      value: "DEU",
      label: "Deutsch",
      flagUrl:
        "https://upload.wikimedia.org/wikipedia/commons/b/ba/Flag_of_Germany.svg",
    },
  ];

  const activeLang = langs.find((x) => x.value === lang.id);

  const handleChange = (value) => {
    changeLanguage(value);
  };

  return (
    <Menu withArrow offset={0}>
      <Menu.Target>
        <Button
          leftSection={
            <img
              src={activeLang.flagUrl}
              width={24}
              alt="flag"
              rel="noreferrer"
              referrerPolicy="no-referrer"
            />
          }
          variant={"white"}
          size="md"
          rightSection={<IconChevronDown size={18} />}
          w={160}
        >
          {activeLang.label}
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        {langs.map((item, index) => (
          <>
            {index !== 0 && <Divider my={4} opacity={0.5} />}
            <Menu.Item
              key={item.value}
              onClick={() => handleChange(item.value)}
            >
              <Group fz={15}>
                <img
                  src={item.flagUrl}
                  width={24}
                  alt="flag"
                  rel="noreferrer"
                  referrerPolicy="no-referrer"
                />
                {item.label}
              </Group>
            </Menu.Item>
          </>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default SupportLanguageChanger;
